import React, { useEffect, useRef } from 'react';

interface InfiniteScrollSentinelProps {
    onLoadMore: () => void;
    disabled?: boolean;
}

export default function InfiniteScrollSentinel({ onLoadMore, disabled = false }: InfiniteScrollSentinelProps) {
    const sentinelRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (disabled) return;

        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    onLoadMore();
                }
            },
            { threshold: 0, rootMargin: '100px' }
        );

        const sentinel = sentinelRef.current;
        if (sentinel) observer.observe(sentinel);

        return () => observer.disconnect();
    }, [onLoadMore, disabled]);

    return <div ref={sentinelRef} style={{ height: 1, minHeight: 1 }} />;
}
